import type {ReactAction} from '@netx/core/bootstrap';
import {faUsersCog} from '@netx/core-icons';
import {canShareSavedCartWithTeam} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionTeamAccessIcon = faUsersCog;

/**
 * Saved cart share team access
 * @param params
 * @returns Action
 */
export const cartSavedActionTeamAccess = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-share-team-access',
	cb: () => dispatcher.trigger(CART_SAVED_EVENT.SHARE_TEAM_ACCESS, savedCart),
	enableTest: () => canShareSavedCartWithTeam(savedCart),
	icon: cartSavedActionTeamAccessIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.SHARE_TEAM_ACCESS;
	},
	...params,
});

export default cartSavedActionTeamAccess;
